import Text from '@shared/components/content/text';
import { cn } from '@shared/lib/utils';

interface ActivityCellProps {
  name: string;
  remoteId?: string;
  supplierName?: string;
  className?: string;
}

export function ActivityCell({
  name,
  remoteId,
  supplierName,
  className,
}: ActivityCellProps) {
  return (
    <div className={cn(className, '', {})}>
      <div className="flex items-center gap-2">
        {remoteId && (
          <Text variant="unit" className="font-medium">
            {remoteId}
          </Text>
        )}
        {supplierName && <Text variant="unit">{supplierName}</Text>}
      </div>
      <Text className="min-w-[150px]" includeHover>
        {name}
      </Text>
    </div>
  );
}
